import React from 'react';
import { grey } from '@mui/material/colors';
import { TableCell, TableHead, TableRow } from '@mui/material';
import { MUIBaseEntity, MUITableHeaderProps } from './types';
import { MUITableHeaderWithSort } from './MUITableHeaderWithSort';

export const MuiTableHeader = <TableEntity extends MUIBaseEntity>({
  columns,
  sorting,
}: MUITableHeaderProps<TableEntity>) => (
  <TableHead className="tableHead">
    <TableRow>
      {columns.map(column => {
        const isSorted = sorting?.key === column.sortKey;

        return (
          <TableCell
            align="center"
            key={column.renderKey}
            sortDirection={isSorted ? sorting?.value : false}
            sx={{
              backgroundColor: grey[50],
              '& .MuiTableSortLabel-root': {
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
              },
            }}
          >
            {!!column?.sortKey && sorting ? (
              <MUITableHeaderWithSort<TableEntity> sorting={sorting} isSorted={isSorted} column={column} />
            ) : (
              column.header
            )}
          </TableCell>
        );
      })}
    </TableRow>
  </TableHead>
);
